<div class="email-send-overlay">
    <div class="email-sending-spinner-container">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#EEEEEE"
            animationDuration=".8s"></p-progressSpinner>
        <p>
            Loading... ⌛
        </p>
    </div>
</div>